import { api } from "@/lib/api";

export type Company = {
  id: string;
  name: string;
  description: string | null;
  status: string;
  issuePrefix: string;
  budgetMonthlyCents: number;
  spentMonthlyCents: number;
  brandColor: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DashboardSummary = {
  companyId: string;
  agents: { active: number; running: number; paused: number; error: number };
  tasks: Record<string, number>;
  costs: {
    monthSpendCents: number;
    monthBudgetCents: number;
    monthUtilizationPercent: number;
  };
  kpis: {
    /** % de tasks aprovadas vs canceladas nos últimos 30d. null = sem dados */
    approvalRatePercent: number | null;
    approvalSampleSize: number;
    /** Tempo médio de entrega das últimas 10 tasks done (ms) */
    avgDeliveryMs: number | null;
    deliverySampleSize: number;
    /** Quantas integrações conectadas */
    connectedIntegrations: number;
    /** Últimos 3 ESCALA assessments pra mostrar trend */
    escalaHistory: Array<{ completedAt: string; avgScore: number }>;
  };
  pendingApprovals: number;
  budgets: {
    activeIncidents: number;
    pendingApprovals: number;
    pausedAgents: number;
    pausedProjects: number;
  };
};

export const companiesApi = {
  list: () => api.get<{ companies: Company[] } | Company[]>("/companies"),
  detail: (id: string) => api.get<Company>(`/companies/${id}`),
  dashboard: (id: string) => api.get<DashboardSummary>(`/companies/${id}/dashboard`),
  /**
   * Reset de conta (ferramenta de QA — só funciona no ambiente de dev).
   * Zera a empresa de volta ao primeiro acesso: apaga onboarding, ESCALA, KBs,
   * issues e todo o resto, re-semeia agentes/rotinas/budget e mantém a mesma
   * empresa (id estável).
   */
  reset: (id: string) => api.post<Company>(`/companies/${id}/reset`, {}),
};
